import { createStyles, rem } from '@mantine/core'

import { hexToRgb, hsbToRgb, rgbToHsb } from 'utils/colors'

export interface StylesParams {
  layout: 'horizon' | 'vertical'
  bgColor: string
  fullWidth?: boolean
  isSelected?: boolean
  useBgColor?: boolean
}

function getLightenColor(color: string) {
  const rgb: any = hexToRgb(color, true)
  const hsb = rgbToHsb(rgb.r, rgb.g, rgb.b)
  const newRgb = hsbToRgb(hsb[0], 8, 99)
  const bgColor = `rgb(${newRgb[0]},${newRgb[1]},${newRgb[2]})`
  return bgColor
}

export default createStyles((theme, params: StylesParams) => {
  const { layout, bgColor, fullWidth, useBgColor } = params
  return {
    root: {
      position: 'relative',
      display: 'flex',
      padding: `${rem(16)} ${rem(8)}`,
      gap: layout === 'vertical' ? rem(16) : rem(12),
      boxShadow:
        '0px 0px 1px 0px rgba(0, 0, 0, 0.04), 0px 2px 8px 0px rgba(0, 0, 0, 0.04), 0px 16px 24px 0px rgba(0, 0, 0, 0.06)',
      alignItems: 'center',
      cursor: 'pointer',
      borderRadius: rem(16),
      background: useBgColor ? getLightenColor(bgColor) : '#fff',
      ...(layout === 'vertical' && {
        flexDirection: 'column',
      }),

      [theme.fn.largerThan('sm')]: {
        padding: layout === 'vertical' ? `${rem(24)} ${rem(12)}` : rem(24),
        gap: rem(24),
      },
      ...(fullWidth && {
        width: '100%',
        justifyContent: 'center',
      }),
    },
    imgWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: bgColor,
      width: rem(40),
      height: rem(40),
      borderRadius: rem(12),
      flexShrink: 0,
      [theme.fn.largerThan('sm')]: {
        borderRadius: rem(16),
        width: rem(56),
        height: rem(56),
      },
    },
    title: {
      textAlign: layout === 'vertical' ? 'center' : 'left',
    },
    hint: {
      position: 'absolute',
      bottom: 0,
      zIndex: 3,
      // paddingBottom: isQuare ? rem(8) : 0,
      paddingLeft: rem(10),
      [theme.fn.largerThan('sm')]: {
        paddingLeft: rem(20),
        // paddingBottom: isQuare ? rem(12) : 0,
      },
    },
    popoperDropdown: {
      padding: 0,
      border: 0,
    },
    popoperArrow: {
      backgroundColor: theme.colors.neutral[0],
    },
    disclaimer: {
      padding: rem(8),
      border: `1px solid ${theme.colors.neutral[1]}`,
      backgroundColor: theme.colors.neutral[0],
      textAlign: 'center',
    },
    disclaimerText: { fontSize: rem(12), lineHeight: rem(18) },
    externalIcon: {
      position: 'absolute',
      right: rem(10),
      [theme.fn.smallerThan('sm')]: {
        top: '50%',
        transform: `translate(0, -50%)`,
      },
      [theme.fn.largerThan('sm')]: {
        top: rem(10),
      },
    },
  }
})
